<h2>{{'claims-center.audanetIntegration.partsInfo' | translate}}</h2>
<kendo-grid [data]="costEstimationParts" style="max-width: 1024px;" [size]="'small'">

    <kendo-grid-column field="description" title="{{'claims-center.claimCostEstimations.partDescription' | translate}}"
        [width]="40">
        <ng-template kendoGridCellTemplate let-part="dataItem">
            {{part.description}}
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="code" title="{{'claims-center.claimCostEstimations.partIdentifier' | translate}}"
        [width]="40">
        <ng-template kendoGridCellTemplate let-part="dataItem">
            {{part.code}}
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="quantity" class="k-text-right" title="{{'claims-center.claimCostEstimations.quantity' | translate}}"
        [width]="15">
        <ng-template kendoGridCellTemplate let-part="dataItem">
            {{part.quantity | number : '1.2-2' }}
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="price"  class="k-text-right" title="{{'claims-center.claimCostEstimations.price' | translate}}" [width]="15">
        <ng-template kendoGridCellTemplate let-part="dataItem">
            {{part.price | number : '1.2-2' }}
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column field="price"  class="k-text-left" title="{{'claims-center.claimCostEstimations.includeInPartsOrder' | translate}}" [width]="40">
        <ng-template kendoGridCellTemplate let-part="dataItem">
            
            <div *ngIf="!viewMode">
                <kendo-icon class="pointer" *ngIf="part.includeInPartsOrder" name="check" [themeColor]="'success'" [size]="size" (click)="toogleIncludePartInPartsOrder(part)"></kendo-icon>
                <kendo-icon class="pointer" *ngIf="!part.includeInPartsOrder" name="cancel" [themeColor]="'error'" [size]="size" (click)="toogleIncludePartInPartsOrder(part)"></kendo-icon>
            </div>

            <div *ngIf="viewMode">
                <kendo-icon *ngIf="part.includeInPartsOrder" name="check" [themeColor]="'success'" [size]="size"></kendo-icon>
                <kendo-icon *ngIf="!part.includeInPartsOrder" name="cancel" [themeColor]="'error'" [size]="size"></kendo-icon>
            </div>
            
           
            <span class="small-info" *ngIf="part.reasonForNotOrdering">
                {{part.reasonForNotOrdering}}
            </span>
        </ng-template>
    </kendo-grid-column>

</kendo-grid>

<div kendoDialogContainer #costEstimationPartsDialog></div>